var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpBox',[_c('IxRes',[_vm._v("frs.navigation.tags.hints.pleaseSelectSomething")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }